import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import smsReducer from "./sms/_smsReducer";
import authReducer from './auth/_authReducer';
import utilsReducer from './utils/_utilsReducer';

export default (history) =>
    combineReducers({
        router: connectRouter(history),
        sms: smsReducer,
        auth: authReducer,
        utils: utilsReducer
    });

// const rootReducers = combineReducers({
//     sms: smsReducer,
//     auth: authReducer,
//     utils: utilsReducer
// });

// export default rootReducers;